import {z} from 'zod';

import {InventoryTurnoverQuerySchema} from '@prompt-bridge/shared/validations';

type InventoryTurnoverQueryInput = z.input<typeof InventoryTurnoverQuerySchema>;

const toValues = (value: string | string[] | undefined) => {
  if (value === undefined) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
};

export function inventoryTurnoverSearchParams(filters: InventoryTurnoverQueryInput) {
  const params = new URLSearchParams();
  if (filters.asOf !== undefined) {
    params.append('asOf', filters.asOf);
  }
  for (const id of toValues(filters.branch)) {
    params.append('branch', id);
  }
  for (const id of toValues(filters.warehouse)) {
    params.append('warehouse', id);
  }
  return params.toString();
}
